<template>
  <div
    id="app"
    :class="{ 'tc-app-brand': useTcBrand }"
  >
    <div
      class="bg-gray-100 min-h-screen"
    >
      <!--
        Wait for the initial route to resolve before rendering a shell. Auth
        can finish while a lazy route is still loading.
        No fade here: a transition that is still entering when the route
        hides the shell leaves an orphan header in the DOM on every fresh
        load of a hideShell page.
      -->
      <HeaderFixed v-if="$route.matched.length && $store.state.employers.authorisationAttempted && !$route.meta.hideShell" />

      <HeaderAssessments v-if="$route.meta.candidateWizard" />

      <PlatformUpdateBanner />

      <transition
        name="tc-employer-page"
        mode="out-in"
        :css="useTcBrand"
      >
        <RouterView :key="useTcBrand && $route.name === 'client-assessments-list' ? $route.path : $route.fullPath"/>
      </transition>

      <portal-target
        name="modals"
        multiple
      ></portal-target>
      <portal-target name="slide-overs"></portal-target>
    </div>
  </div>
</template>

<script>
import PlatformUpdateBanner from '@components/PlatformUpdateBanner'
import HeaderFixed from '@components/HeaderFixed'
import HeaderAssessments from '@components/Assessments/AssessmentsHeader'

export default {
  components: {
    PlatformUpdateBanner,
    HeaderFixed,
    HeaderAssessments
  },

  computed: {
    useTcBrand() {
      return (
        process.env.VUE_APP_SATELLITE === 'testcandidates' &&
        !this.$route.matched.some(route => route.meta.assessment || route.meta.candidateWizard)
      )
    }
  },

  mounted() {
    document.addEventListener('click', this.closeOtherMenus)
    document.addEventListener('keydown', this.closeMenusOnEscape)
    document.addEventListener('tc-menu-open', this.closeOtherMenus)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeOtherMenus)
    document.removeEventListener('keydown', this.closeMenusOnEscape)
    document.removeEventListener('tc-menu-open', this.closeOtherMenus)
  },
  beforeCreate() {
    // Used for App Loading screen
    // Keep outreach's branded boot message until its lazy route resolves.
    // Marking the shell loaded first leaves an empty RouterView on slow loads.
    if (/^\/outreach\//.test(window.location.pathname)) {
      this.$router.onReady(() => { window.APP_LOADED = true })
      return
    }
    window.APP_LOADED = true
  },
  methods: {
    closeOtherMenus(event) {
      if (!this.useTcBrand) return
      document.querySelectorAll('details.tc-list-menu[open]').forEach(menu => {
        if (!menu.contains(event.target)) menu.open = false
      })
    },
    closeMenusOnEscape(event) {
      if (!this.useTcBrand || event.key !== 'Escape') return
      document.querySelectorAll('details.tc-list-menu[open]').forEach(menu => {
        menu.open = false
        menu.querySelector('summary').focus()
      })
    }
  },

  page: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: process.env.VUE_APP_SATELLITE_NAME,
    // all titles will be injected into this template
    titleTemplate: `%s | ${process.env.VUE_APP_SATELLITE_NAME}`
  }
}
</script>

<style>
@import "~@assets/css/tailwind.css";
@import "~@assets/css/tc-brand.css";
@import "~@assets/css/tc-auth.css";
@import "~@assets/css/tc-employer-v2.css";

/*
 * Keep the vertical scrollbar's space reserved on every page, so content
 * that is centred with mx-auto does not shift sideways when a long page
 * (or a modal locking the body) adds or removes the scrollbar.
 */
html {
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
</style>
